const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/HospitalImgCard/HospitalImgCard.tsx';
import React from 'react';
import { Card } from '@mui/material';
import Grid from '@mui/material/Grid';
import { css } from '@emotion/css';
import { ImageInplaceLoader } from 'App/components/ImageClientLoader/ImageClientLoader';
import useBreakpoint from '@cistec/common_web/hooks/useBreakpoint';
import { useTheme } from '@mui/material/styles';

export interface Props {}

const pictureStyle = css`
    max-width: 100%;
    margin-bottom: -4px;
`;

export const HospitalImgCard = (props: Props) => {
    const theme = useTheme();
    const isSmallDevice = useBreakpoint(theme.breakpoints.values.sm);
    if (isSmallDevice) return;

    return (
        <Grid size={{ xs: 12 }}>
            <Card>
                <ImageInplaceLoader className={pictureStyle} src={'Picture'} />
            </Card>
        </Grid>
    );
};
